import { render, staticRenderFns } from "./scroll-down.vue?vue&type=template&id=4e388510&scoped=true&"
import script from "./scroll-down.vue?vue&type=script&lang=js&"
export * from "./scroll-down.vue?vue&type=script&lang=js&"
import style0 from "./scroll-down.vue?vue&type=style&index=0&id=4e388510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e388510",
  null
  
)

export default component.exports